import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Modal from 'react-modal';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalContext from './context';
import { Router } from './routes';
import { GlobalStyle } from './styles/global';

Modal.setAppElement('#root');

const App = () => {
  return (
    <ErrorBoundary>
      <DndProvider backend={HTML5Backend}>
        <GlobalContext>
          <Router />
          <GlobalStyle />
        </GlobalContext>
      </DndProvider>
    </ErrorBoundary>
  );
};

export default App;
